<script>
import appConfig from "@/app.config";
import Km from "../../../components/document/schedules/km.vue"
import En from "../../../components/document/schedules/en.vue"
import { saleService } from "../../../services/saleservice/sale.service";
/* eslint-disable no-console */
/**
 * Invoice-detail component
 */

export default {
  page: {
    title: "Invoice Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Km,
    En
  },
  data() {
    return {
      title: "Invoice Detail",
      items: [
        {
          text: "Invoices",
          href: "/",
        },
        {
          text: "Detail",
          active: true,
        },
      ],

      template: 3,
      saledetail: null,
      saleschedule: null,
      registerDates: [],
      loan: null,
      loanDuration: 0,
    };
  },
  mounted() {
    
    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else if('propertyid' in this.$route.query) {
      this.loadingPropertyById(this.$route.query.propertyid);
    }
    
  },
  methods: {
    
     
    loadingData: function(id) {
      
      this.fetchingStats = false;
      saleService.saledetail(id)
        .then(response => {
          this.saledetail = response.data;
          // this.registerDates = this.saledetail.register_date_show.split('-');
          this.template = this.saledetail.template_id;
        });

      saleService.saleschedule(id)
        .then(response => {
          this.saleschedule = response.data;
          this.loan = this.saleschedule.find(item => { return item.interest > 0 });
          let index = this.saleschedule.findIndex(item => item.interest > 0);

          this.loanDuration = this.saleschedule.length - index;
        });
    
    },

    loadingPropertyById: function(id) {
      this.fetchingStats = false;

      saleService.getOneByProperty(id).then(response => {
        if(response.data != null) {
          saleService.saledetail(response.data.id)
            .then(response => {
              this.saledetail = response.data;
              // this.registerDates = this.saledetail.register_date_show.split('-');

              this.template = this.saledetail.template_id;

              // console.log('hello world');
            });

          saleService.saleschedule(response.data.id)
            .then(response => {
              this.saleschedule = response.data;

              this.loan = this.saleschedule.find(item => { return item.interest > 0 });
              let index = this.saleschedule.findIndex(item => item.interest > 0);
              this.loanDuration = this.saleschedule.length - index;
            });
        }
      });
    },

  },
};
</script>

<template>
  <Km v-if="template == 3"
    :saleDetail="saledetail"
    :saleSchedule="saleschedule"
    :loans="loan"
    :duration="loanDuration"

   />
  <En v-else
    :saleDetail="saledetail"
    :saleSchedule="saleschedule"
    :loans="loan"
    :duration="loanDuration"

   />
</template>